import { Component, input } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { AnalyticsContextComponent } from '../../analytics/analytics-context.component';
import { NotificationsToastComponent } from '../notifications-toast.domain';
import { ToastMessage } from './toast-message.domain';

@Component({
  templateUrl: 'toast-message.component.html',
  styleUrls: ['toast-message.component.scss'],
  imports: [
    AnalyticsContextComponent,
    IconComponent
  ]
})
export class ToastMessageComponent implements NotificationsToastComponent<ToastMessage> {
  readonly toast = input<ToastMessage>(undefined);
}
